import { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async'

declare global {
  interface Window {
    embeddedservice_bootstrap: any
  }
}

export function Salesforce() {
  const hasMountedRef = useRef(false)

  useEffect(() => {
    if (hasMountedRef.current) return

    const initEmbeddedMessaging = () => {
      try {
        window.embeddedservice_bootstrap.settings.language = 'en_US'
        window.embeddedservice_bootstrap.init(
          '00D1a000000aEOE',
          'Cloud_Agent_Suite_Messaging_for_Web',
          'https://lonewolf.my.site.com/ESWCloudAgentSuiteMess1762371822979',
          {
            scrt2URL: 'https://lonewolf.my.salesforce-scrt.com'
          }
        )
      } catch (err) {
        console.error('Error loading Embedded Messaging: ', err)
      }
    }

    if (!window.embeddedservice_bootstrap) {
      const s = document.createElement('script')
      s.setAttribute('type', 'text/javascript')
      s.setAttribute(
        'src',
        'https://lonewolf.my.site.com/ESWCloudAgentSuiteMess1762371822979/assets/js/bootstrap.min.js'
      )
      s.onload = () => initEmbeddedMessaging()
      document.body.appendChild(s)
    } else {
      initEmbeddedMessaging()
    }
  }, [])

  useEffect(() => {
    hasMountedRef.current = true

    return () => {
      hasMountedRef.current = false
    }
  }, [])

  return <Helmet></Helmet>
}
